export default __webpack_public_path__ + "static/home_logistic-b7b01d9476a78ed1aacbcb59e47e67b9.jpg";